<div style="height: 100vh !important;">
    <router-outlet></router-outlet>
</div>